var render = function render(){var _vm=this,_c=_vm._self._c;return _c('button',{staticClass:"resend-option",attrs:{"type":"button"},on:{"click":function($event){return _vm.$emit('click')}}},[(_vm.icon)?_c('img',{staticClass:"resend-icon",attrs:{"src":_vm.icon}}):_vm._e(),_vm._v(" "),_c('span',{staticClass:"resend-text"},[_vm._v(_vm._s(_vm.text))])])
}
var staticRenderFns = []

export { render, staticRenderFns }